var appSettings = {
        base_url: process.env.REACT_APP_ENDPOINT,
        admin_backend_url: process.env.REACT_APP_ASSET_ENDPOINT,
        react_app_endpoint: process.env.REACT_APP_FRONTEND,
        recordsPerPage: 25,
        recordsPerPageTable: 25,
        stripeKey: process.env.REACT_APP_PUBLISHABLE_KEY,
    }
export default appSettings